<hpf-about-form
        [about]="about"
        [loading]="about.isNew()"
        (update)="onUpdate()"
        (delete)="onDelete()"
    ></hpf-about-form>
